<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" />
<div class="ecpl-tree-view">
  <div class="search-block">
    <input #filter class="form-control" (keyup)="filterNodes(filter.value, ecplTree)"
      placeholder="{{ 'FILTER_NODES' | translate }}" />
  </div>
  <!-- Drag and drop is handled on .node-wrapper, not by PrimeNG's draggableNodes/droppableNodes:
       p-tree only subscribes to its drag service when droppableNodes is already true at init,
       so it never worked for trees that switch into edit mode after loading. -->
  <p-tree id="{{ treeId }}" #ecplTree class="reverse" [value]="filteredPrimeNodes"
    selectionMode="single" [(selection)]="selection"
    (onNodeExpand)="onNodeExpand($event)"
    (onNodeCollapse)="onNodeCollapse($event)" (onNodeSelect)="onNodeSelect($event)"
    (onNodeUnselect)="onNodeUnselect($event)">
    <ng-template let-node pTemplate="default" let-index="index">
      <div *ngIf="
          node.data.filename == 'Checklist Under Completion' ||
          ecplTreeCheckbox ||
          (node.data.isPermission &&
            (node.data.documentType != 'laws' || node.data.isFolder != false) &&
            (node.data.filename != 'Regulation' ||
              node.data.isFolder != false) &&
            (node.data.documentType != 'videos' || node.data.isFolder != false))
        ">
        <div class="node-wrapper" (contextmenu)="onContextMenu($event, node)"
          (click)="scheduleLabelToggle(node)" (dblclick)="cancelLabelToggle()"
          [class.ecpl-drop-target]="node === dropTargetNode" [attr.draggable]="isNodeDraggable(node)"
          (dragstart)="onNodeDragStart(node, $event)" (dragend)="onNodeDragEnd($event)"
          (dragover)="onNodeDragOver(node, $event)" (dragleave)="onNodeDragLeave(node, $event)"
          (drop)="onNodeDrop(node, $event)">
          <!-- Show "eye" icons to hide/show files in manuals, documents and archive. -->
          <!-- Arrow for folders with children -->
          <span class="ecpl-node-expander" (click)="toggleNode(node, $event)"
            *ngIf="node.children && node.children.length > 0" [class.expander-visible]="node === selectedNode"></span>
          <!-- Placeholder for leaf nodes to maintain alignment -->
          <span class="ecpl-node-expander" *ngIf="!node.children || node.children.length === 0"
            style="visibility: hidden"></span>
          <!-- Eye icon for edit mode only -->
          <div *ngIf="ecplTreeCheckbox && !addFromManuals">
            <span class="tooltip-container">
              <i class="fa" [ngClass]="getIconClass(node.data)" [attr.name]="node.data.id" [attr.id]="node.data.id"
                (click)="
                  node.data.isPermission !== false &&
                    setNodeStatus(node, $event)
                " [ngStyle]="{
                  cursor:
                    node.data.isPermission !== false ? 'pointer' : 'not-allowed'
                }"></i>
              <span class="tooltip-text">
                {{ getTooltipText(node.data) }}
              </span>
            </span>
          </div>
          <!-- Replace "eye" icons with select-check-boxes in "add from manuals". -->
          <div *ngIf="ecplTreeCheckbox && addFromManuals">
  <span class="tooltip-container">
    <input
      type="checkbox"
      [attr.name]="node.data.id"
      [attr.id]="node.data.id"
      [checked]="node.data.status === 1"
      (click)="$event.stopPropagation()"
      (change)="node.data.isPermission !== false && setNodeStatus(node, $event)"
      [ngStyle]="{
        cursor: node.data.isPermission !== false ? 'pointer' : 'not-allowed'
      }"
    />
  </span>
          </div>

          <span class="ecpl-node-icon" aria-hidden="true">
            <i [class]="getFileIcon(node)"></i>
          </span>
          <!-- Prohibited icon for default folders in edit mode -->
          <span *ngIf="ecplTreeCheckbox && node.data.isDefault && node.data.isFolder"
            class="tooltip-container default-folder-lock" style="margin-left: 5px; background-color: #ffffff;">
            <i class="fa fa-ban" style="color: #dc3545; cursor: not-allowed;"></i>
            <span class="tooltip-text">
              {{ 'DEFAULT_FOLDER_RESTRICTION' | translate }}
            </span>
          </span>
          <div class="node-content-wrapper">
            <div [class.col-sm-9]="node.data.additionalFeatureId == 186"
              [class.node-disabled]="node.data.status === 2" [class.node-content-wrapper-active]="node === selectedNode"
              [class.node-content-wrapper-focused]="node === focusedNode" (click)="onNodeClick(node, $event)"
              (dblclick)="onNodeDblClick(node, $event)" (contextmenu)="onNodeContextMenu(node, $event)">
              <tree-node-content [node]="node | defaultFolderTranslate" [index]="index">
              </tree-node-content>
              <span class="badge" *ngIf="
                  node.data.type != 'file' &&
                  node.data.documentType != 'laws' &&
                  node.data.documentType != 'regulation' &&
                  node.data.filename != 'Regulation'
                ">
                <span *ngIf="
                    node.data.documentType != 'laws' &&
                    node.data.documentType != 'regulation' &&
                    node.data.filename != 'Regulation'
                  ">{{ node.data.nodes | activeFolderCount }}
                </span>
                <span *ngIf="
                    node.data.type != 'file' &&
                    node.data.documentType != 'laws' &&
                    node.data.documentType != 'regulation' &&
                    node.data.filename != 'Regulation'
                  ">
                  /
                </span>
                <span *ngIf="
                    node.data.type != 'file' &&
                    node.data.documentType != 'laws' &&
                    node.data.documentType != 'regulation' &&
                    node.data.filename != 'Regulation'
                  ">
                  {{ node.data.nodes | activeFileCount }}
                </span>
              </span>
            </div>
            <div class="col-sm-3 p-0" *ngIf="node.data.additionalFeatureId == 186">
              <span *ngIf="!node.data.isFolder" style="float: right">
                <button *ngIf="!isClientUser"  (click)="editClick(node.data)" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-pencil"></i>
          </button>
                <button  (click)="printClick(node.data)" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-print"></i>
          </button>
                <button *ngIf="!isClientUser"  (click)="deleteClick(node.data)" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
              </span>
              <span *ngIf="node.data.isFolder" style="float: right">
                <button class="btn btn-primary" (click)="printClick(node.data)">
                  <span translate>INSPECTION_REPORT</span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-tree>

  <!-- Editors and Viewers -->
  <div #hiddenAction style="width: 1px; height: 1px; overflow: hidden" *ngIf="file != null">
    <ecpl-image-viewer *ngIf="
        file.path != null &&
        humanizeType(getFileExtension(file.path)) == 'Image'
      " [imgSrc]="file.path" [imgType]="getFileExtension(file.path)" [imgName]="file.filename" [id]="file.nodeId"
      [isDialog]="true" [forceReopen]="fileSelectionCounter" thumbNail="true">
    </ecpl-image-viewer>

    <ecpl-article-viewer #articleViewerRef *ngIf="file.type == 'file' && file.documentType == 'article'"
      [articleName]="file.filename" [(articleSrc)]="file.content" [id]="file.nodeId" [adminUsers]="adminUsers"
      [businessMode]="businessMode" [editMode]="ecplTreeCheckbox" (saveChanges)="saveFolderFile($event)"
      [(ecplApiResponse)]="ecplApiResponse">
    </ecpl-article-viewer>

    <ecpl-onlyoffice-viewer *ngIf="
        file.path != null &&
        humanizeType(getFileExtension(file.path)) == 'Document'
      " [onlyofficeSrc]="file.path.replace('azureedge', 'blob.core.windows')" [onlyofficeKey]="file.nodeId + 'key'"
      [onlyofficeType]="getFileExtension(file.path)" [onlyofficeName]="file.filename" [id]="file.nodeId"
      [isDialog]="true" [forceReopen]="fileSelectionCounter" [onlyofficeMode]="
        ecplTreeCheckbox === true
          ? file.isEditable === false
            ? false
            : true
          : false
      " (saveChanges)="saveFolderFile($event)"></ecpl-onlyoffice-viewer>

    <ecpl-pdf-viewer *ngIf="
        file.path != null && humanizeType(getFileExtension(file.path)) == 'Pdf'
      " [id]="file.nodeId" [pdfSrc]="file.path" [pdfName]="file.filename" [isDialog]="true"
      [forceReopen]="fileSelectionCounter"></ecpl-pdf-viewer>

    <ecpl-checklist-viewer #checklistViewerRef *ngIf="
        file.type == 'file' &&
        file.documentType == 'checklist' &&
        file.featureId != 36
      " [checklistName]="file.filename" [(checklistSrc)]="file" [id]="file.nodeId" [editMode]="ecplTreeCheckbox"
      [isDialog]="true" [forceReopen]="fileSelectionCounter"
      (saveChanges)="saveFolderFile($event)"></ecpl-checklist-viewer>

    <ecpl-lar-viewer #larViewerRef *ngIf="
        file.documentType === 'law' ||
        file.documentType === 'laws' ||
        file.documentType === 'regulation' ||
        file.documentType === 'videos'
      " [name]="file.filename" [(larSrc)]="file.content" [mode]="ecplTreeCheckbox" [id]="file.nodeId"
      (saveChanges)="saveFolderFile($event)"></ecpl-lar-viewer>
  </div>
</div>

<p-contextMenu #cm [model]="contextMenuItems" appendTo="body"></p-contextMenu>

<!-- New Folder Modal -->
<ng-template #newFolderModal>
  <div class="modal-header">
    <h4>{{ bsModalTitle }}</h4>
    <button type="button" class="btn btn-icon close" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form class="form-inline">
      <div class="form-group">
        <input *ngIf="newFolderNode" type="text" [(ngModel)]="newFolderNode.filename" name="folderName" id="folderName"
          class="form-control" style="width: 300px" />
      </div>

      <button type="button" class="btn btn-primary" [disabled]="!newFolderNode.filename.trim()"
        (click)="saveFolderFile(currentEventData)">
        <span translate>SAVE</span>
      </button>
    </form>
  </div>
</ng-template>

<!-- Alert Dialog (replaces native browser alert) -->
<p-dialog [(visible)]="showAlertDialog" header="ik.kuba.no says" [showHeader]="true" [modal]="true" [closable]="true"
  [style]="{ width: '500px' }" [resizable]="false" [draggable]="false" [closeOnEscape]="true">
  <div class="alert-dialog-content">
    <div class="alert-dialog-message">
      {{ alertDialogMessage }}
    </div>
    <div>
      <button type="button" class="btn btn-primary" (click)="closeAlertDialog()">
        <span translate>CLOSE</span>
      </button>
    </div>
  </div>
</p-dialog>
